
/* Single image */
import img1 from '../images/service/img-1.jpg'
import img2 from '../images/service/img-2.png'
import img3 from '../images/service/img-3.jpg'
import img4 from '../images/service/img-4.jpg'
import img5 from '../images/service/img-5.jpg'
import img6 from '../images/service/img-6.jpg'
// import img7 from '../images/service/img-7.jpg'
// import img8 from '../images/service/img-8.jpg'
// import img9 from '../images/service/img-9.jpg'
// import img10 from '../images/service/img-10.jpg'
// import img11 from '../images/service/img-11.jpg'



import Simg1 from '../images/service-single/img-1.jpg'
import Simg2 from '../images/service-single/img-2.jpg'
import Simg3 from '../images/service-single/img-3.jpg'
import Simg4 from '../images/service-single/img-4.jpg'
import Simg5 from '../images/service-single/img-5.jpg'
import Simg6 from '../images/service-single/img-6.jpg'
// import Simg7 from '../images/service-single/img-7.jpg'
// import Simg8 from '../images/service-single/img-8.jpg'
// import Simg9 from '../images/service-single/img-9.jpg'
// import Simg10 from '../images/service-single/img-10.jpg'
// import Simg11 from '../images/service-single/img-11.jpg'

const Services = [
    {
        id: 1,
        image: img1,
        simag: Simg1,
        subtitle: 'Transport',
        title: 'Storage',
        description: 'We provide modern warehouse facilities for storing your goods. Our warehouses are equipped with advanced security and climate control systems, which guarantees the safety of your property in any conditions. We offer flexible rental terms and a wide range of additional services, such as inventory management, labeling and order picking. Our specialists are always ready to help you choose the best solution for your business.',
        slug: 'Air-Transport'
    },
    {
        id: 2,
        image: img2,
        simag: Simg2,
        subtitle: 'Transport',
        title: 'Logistics',
        description: 'Our company offers comprehensive logistics solutions that optimize supply chains and ensure timely delivery of goods. We develop individual logistics strategies, taking into account all the features of your business, so that you can focus on development, not on transport problems. Our specialists use modern technologies to track and manage cargo flows, ensuring a high level of service and minimizing costs. ',
        slug: 'Ocean-Transport'
    },
    {
        id: 3,
        image: img3,
        simag: Simg3,
        subtitle: 'Transport',
        title: 'Cargo',
        description: 'Our company specializes in the transportation of cargo of all types and sizes. We offer transportation taking into account all the requirements and features of your cargo, whether it is oversized, dangerous or temperature-sensitive goods. We provide reliable packaging and cargo insurance, as well as prompt execution of all necessary documents. Our services allow you to be confident in the safety and timely delivery of your cargo to any point in the world. ',
        slug: 'Road-Transport'
    },
    {
        id: 4,
        image: img4,
        simag: Simg4,
        subtitle: 'Transport',
        title: 'Auto transportation',
        description: 'We provide road transportation services throughout the country and beyond. Our fleet consists of modern vehicles that meet all safety and environmental standards. We guarantee timely delivery of cargo, regardless of its volume and purpose. Our drivers have extensive experience and high qualifications, which allows us to carry out transportation at the highest level. ',
        slug: 'Road-Transport2'
    },
    {
        id: 5,
        image: img5,
        simag: Simg5,
        subtitle: 'Transport',
        title: 'Package',
        description: 'We offer professional cargo packaging services, ensuring their safety throughout the entire route. Our company uses only high-quality materials and modern packaging technologies, which allows us to protect goods from any damage. We take into account all the features of your cargo and select the best packaging method, be it boxes, pallets or specialized containers. By entrusting us with packaging, you can be sure of the integrity of your cargo. ',
        slug: 'Ocean-Transport2'
    },
    {
        id: 6,
        image: img6,
        simag: Simg6,
        subtitle: 'Transport',
        title: 'Warehousing',
        description: 'Our warehouse services include not only storage, but also a full range of logistics operations, such as sorting, picking and delivery of goods. We have modern warehouses with various storage conditions, which allows us to work with a wide range of goods. We offer individual solutions for each client, ensuring maximum efficiency and minimum lead times. With us, your property is always in good hands. ',
        slug: 'Train-Transport3'
    },

];

export default Services;